<template>
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 12">
		<path fill-rule="evenodd" d="M17.184.383854c.2929.292894.2929.767766 0 1.060656L7.52715 11.1014c-.14065.1406-.33142.2196-.53033.2196-.19891 0-.38968-.079-.53033-.2196L.809636 5.44451c-.292893-.29289-.292893-.76776 0-1.06066.292894-.29289.767764-.29289 1.060664 0l5.12652 5.12653L16.1233.383855c.2929-.2928937.7678-.2928937 1.0607-.000001Z" clip-rule="evenodd"/>
	</svg>
</template>
